var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Minimap"},_vm._l((_vm.textCharacters),function(character,i){return _c('div',{staticClass:"character",class:{
      inputted: (i + 1) <= _vm.playerPosition,
      ghostInputted: (i + 1) <= _vm.ghostPosition
    }},[_vm._v(_vm._s(character))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }